/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ChatBox } from './ChatBox.js'
import FilePopup from '../Popups/FilePopup.js'
import EditChat from './Components/EditChat.js'
import ShareChat from './Components/ShareChat.js'
import AddDatasetPopup from '../Popups/AddDatasetPopup.js'
import PersonaList from '../Personas/PersonaList.js'
import { parseToolCalls, parseMessage, getTokenWindowR, isCUICapableR, getModelInfoR, proposeModelCount, getTokenizerR } from '../Utils/GenAI_helper.js'
import { v4 as uuidv4 } from "uuid";
import Modal from 'react-modal';
import { urlify, strip, unEscapeHTML, escapeHTML } from '../Utils/text_functions.js'
import { get_loading_message, validateFile, removeMetadata } from '../Utils/file_functions.js'
import * as log from 'loglevel'
import { FileManagementDialog } from '../Popups/FileManagement/FileManagementDialog.js';
import { Box, IconButton, Stack, useMediaQuery, useTheme } from '@mui/material';
import { checkMode, scrollToBottom, trimChatHistoryByCount } from '../Utils/chatHelpers.js';
import mermaid from 'mermaid';
import { GoogleOAuthProvider } from '../Contexts/GoogleContext.js';
import {DeepAgentSidebar} from './DeepAgent/DeepAgentSidebar.js';
import { findClarifyingQuestionsAction } from './DeepAgent/DeepAgentParser.js';
import SideMenu from './SideMenu.js';
import { FiMenu } from 'react-icons/fi';

const CoreChat = ({ 
  default_data, 
  userState,
  currentDatasetMode, 
  getWithExpiry, 
  getBotSettingItem, 
  isBotLoggedIn, 
  updateChatTitle, 
  updateChat, 
  getChats, 
  getName, 
  logout, 
  getToken, 
  getUser, 
  setWithExpiry,
  deleteChat,
  Navbar,
  widthStandard = '100vw',
  widthOffset = 0,
  settingsOverride = {},
}) => {
  /* ------------------------------------------------------------------ */
  /* Extract – with fall-backs that match today’s default UX            */
  /* ------------------------------------------------------------------ */
  const {
    disableAutoname     = false,      // keep auto-name logic
    loadUserHistory     = true,       // fetch & show previous chats
    startNewChat        = false,      // don’t force a blank chat
    disableSidebar      = false,      // show history drawer
    saveUserChat        = true,       // write to server / local store
    disableDeepAgent    = false,      // allow deep-agent tools
    disableMobileHeader = false,      // hide mobile header
    hidePluginSelect = false,         // hide plugin selection
    hidePromptSelect = false,         // hide prompt selection
  } = settingsOverride;


  const [prevCommand, setPrevCommand] = useState([]);
  const [commandCount, setCommandCount] = useState(0);
  const [keyCount, setKeyCount] = useState(0);

  const [currentMode, setCurrentMode] = useState("advanced");
  const [chatInput, setChatInput] = useState("simple");
  const [currentModel, setCurrentModel] = useState("gpt");
  const [firstname, setName] = useState("");

  const [sideBarOpen, setSideBarOpen] = useState(false);
  const [hideSideBar, setHideSideBar] = useState(false);

  const [tokens_count, setTokensCount] = useState(0);

  const [loadingText, setLoadingText] = useState("Getting things ready...");

  const [paid, setPaid] = useState(false);
  const [hasStripeID, sethasStripeID] = useState(false);
  const [cur_user, setUser] = useState(null);
  const [CACAuth, setCACAuth] = useState(false);
  const [CUIAuth, setCUIAuth] = useState(false);

  const [temperature, setTemperature] = useState(0.0);
  const [live, setLive] = useState(0);

    const deepAgentSidebarRef = useRef();
    const [deep_agent_infos, setDeepAgentInfos] = React.useState({'infos': [], 'actions': [], 'references': []});
    const [isDeepAgentDrawerOpen, setIsDeepAgentDrawerOpen] = useState(false);
    // Callback to sync state from sidebar
    const handleSidebarOpenChange = (open) => {
      setIsDeepAgentDrawerOpen(open);
    };
    const closeSidebar = () => {
      if (deepAgentSidebarRef.current) {
        deepAgentSidebarRef.current.closeDrawer();
      }
    };
  const [chatMode, setChatMode] = useState('chat');
  const [deep_agent_id, setDeepAgentID] = useState(null);

  const handleChatMode = (mode) => {
    setChatMode(mode);
  }

  const [files, setFiles] = useState([]);

  const [currentChatIndex, setRCurrentChatIndex] = useState(0);
  const currentChatIndexRef = useRef(currentChatIndex);

  const [currentChats, setRCurrentChats] = useState([]);
  const currentChatsRef = useRef(currentChats);

  const [chatButton, setRChatButton] = useState([]);
  const chatButtonRef = useRef(chatButton)

  const [chatLog, setRChatLog] = useState([]);
  const chatLogRef = useRef(chatLog)

  const [isLoading, setIsLoading] = useState(false);
  const [isChartRendering, setIsChartRendering] = useState(false)

  const inputEditRef = useRef(null);
  const [modalIsEditOpen, setIsEditOpen] = React.useState(false);
  const [newEditName, setNewEditName] = React.useState("");
  const [currentEditKey, setCurrentEditKey] = React.useState("");

  const [triggerFilePopup, setTriggerFilePopup] = useState(0);
  const [triggerDatasetPopup, setTriggerDatasetPopup] = useState(0);
  const [triggerFilesPopup, setTriggerFilesPopup] = useState(false);

  const inputShareRef = useRef(null);
  const [modalIsShareOpen, setIsShareOpen] = React.useState(false);
  const [newShareEmail, setNewShareEmail] = React.useState("");
  const [currentShareKey, setCurrentShareKey] = React.useState("");
  const [currentShareName, setCurrentShareName] = React.useState("");
  const [errorShareMessage, setErrorShareMessage] = useState('');
  const [successShareMessage, setSuccessShareMessage] = useState('');
  const [isShareButtonDisabled, setIsShareButtonDisabled] = useState(false);

  const [personas, setPersonas] = useState([]);
  const [current_persona, setCurrentPersona] = useState(1);

  const [datasets, setDatasets] = useState([]);
  const [datasetPermissions, setDatasetPermissions] = useState([]);
  const [datasetEditOnly, setDatasetEditOnly] = useState([]);
  const [secrets, setSecrets] = useState([]);
  const [current_dataset, setCurrentDataset] = useState([{ value: 'all', label: 'All' }]);
  const [finalMessages, setFinalMessages] = useState([]);

  const [triggerPersonaList, setTriggerPersonaList] = useState(0);

  const [loaded, setLoaded] = useState(false);
  var loaded_static = false;

  const showSubscribeBanner = (paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isLoaded, setIsLoaded] = useState(false);
  const [clientId, setClientId] = useState(null);

  useEffect(() => {
    loadGoogleClientId().then((response) => {
      setIsLoaded(true);
      if (response === null || response === undefined) {
        return;
      }
      setClientId(response['client_id']);
    });
  }, []);

  async function loadGoogleClientId() {
    try {
      if (default_data.default_has_google_login_enabled === false) {
        return;
      }
      const response = await fetch(default_data.default_chat_service_url + '/get-google-info', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status !== 200) {
          if (data.status === 404) {
            return null;
          }
          throw new Error('Invalid tokens');
        } else {
          if (data.response === null) {
            return null;
          }
          return data.response;
        }
      } else {
        throw new Error('An error occurred.');
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  const addOrUpdatFinalMessage = useCallback((id, message) => {
    setFinalMessages((prevMessages) => {
      const index = prevMessages.findIndex((msg) => msg.id === id);
      if (index !== -1) {
        const updatedMessages = [...prevMessages];
        updatedMessages[index] = { ...updatedMessages[index], message };
        return updatedMessages;
      } else {
        return [...prevMessages, { id, message }];
      }
    });
  }, []);

  function setCurrentChatIndex(index) {
    setRCurrentChatIndex(index);
    currentChatIndexRef.current = index;
  }

  function setChatButton(button) {
    setRChatButton(button);
    chatButtonRef.current = button;
  }

  function setCurrentChats(chats) {
    setRCurrentChats(chats);
    currentChatsRef.current = chats;
  }

  function setChatLog(chats) {
    setRChatLog(chats);
    chatLogRef.current = chats;
  }

  function showCopyData() {
    setTriggerFilesPopup(true);
  }

  function showPersonaList() {
    setTriggerPersonaList(1);
  }

  function showSimpleIngest() {
    setTriggerFilePopup(1);
  }

  function showAddDataset() {
    setTriggerDatasetPopup(1);
  }

  function closeEditModal() {
    setIsEditOpen(false);
  }

  async function handleEditSubmit(e) {
    e.preventDefault();

    var new_name = newEditName;
    var key = currentEditKey;

    if (key == '') {
      return;
    }

    var newButton = [...chatButtonRef.current];
    const curButton = newButton.find(a => a.key === key.toString());
    if (curButton != null) {
      curButton.content = new_name
      setChatButton(newButton);

      await updateChatTitle(key.toString(), new_name);

      setIsEditOpen(false)
    }
  }

  function editClick(e) {
    var target = isDescendantType('button', e.target);
    if (target === null) {
      return;
    }
    var key = target.dataset.key;
    if (key === null || key === undefined) {
      return;
    }
    key = key.toString();

    e.stopPropagation();

    const curButton = chatButtonRef.current.find(a => a.key === key.toString());
    if (curButton != null) {
      setIsEditOpen(true)
      setNewEditName(curButton.content);
      setCurrentEditKey(key.toString())
    }
  }

  function closeShareModal() {
    setIsShareOpen(false);
  }

  async function handleShareSubmit(e) {
    e.preventDefault();

    var new_email = newShareEmail;
    var key = currentShareKey;

    setErrorShareMessage('');
    setSuccessShareMessage('');

    if (key == '') {
      return;
    }

    const curButton = chatButtonRef.current.find(a => a.key === key.toString());
    if (curButton != null) {
      var token = getToken()
      if (token === false) {
        setErrorShareMessage('Please login again.');
        return;
      }

      var user = getUser()

      if (user === false || user == null) {
        window.location = '/login';
      }

      setIsShareButtonDisabled(true)

      fetch(default_data.default_user_service_url_no_cac + '/copy-chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },
        body: JSON.stringify({
          chat_id: key,
          email: new_email
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if (data.status != 200) {
            // display error
            if (data.status == 401) {
              setErrorShareMessage('Please check that this email is valid.');
            }
            else if (data.status == 400) {
              setErrorShareMessage('Internal error, please contact our customer support.');
            }
            else if (data.status == 410 || data.status == 411) {
              setErrorShareMessage('This email is not from your organization.');
            }
            else {
              setErrorShareMessage('Internal error, please contact our customer support.');
            }
            setIsShareButtonDisabled(false)
            return;
          }
          data = data.response;
          setIsShareButtonDisabled(false)
          setSuccessShareMessage('Success, the chat has been shared.');
          setTimeout(() => {
            setIsShareOpen(false)
          }, 15000);
        })
        .catch(error => {
          setIsShareButtonDisabled(false)
          setErrorShareMessage('Internal error, please contact our customer support.');
          console.log(error);
        });
    }
  }

  function shareClick(e) {
    var target = isDescendantType('button', e.target);
    if (target === null) {
      return;
    }
    var key = target.dataset.key;
    if (key === null || key === undefined) {
      return;
    }

    setSuccessShareMessage('');
    setErrorShareMessage('');
    setIsShareOpen(true)
    setIsShareButtonDisabled(false)
    key = key.toString();

    e.stopPropagation();

    const curButton = chatButtonRef.current.find(a => a.key === key.toString());
    if (curButton != null) {
      setCurrentShareName(curButton.content);
      setCurrentShareKey(key.toString())
    }
  }

  function handleFileChange(event) {
    const newFiles = Array.from(event.target.files);
    const validFiles = newFiles.filter((file) => validateFile(file));
    if (validFiles.length < newFiles.length) {
      alert('Some files were not valid and have been skipped.');
    }
    setFiles((prev) => {
      const updatedFiles = [...prev, ...validFiles];
      if (updatedFiles.length > default_data.default_max_files_attachment) {
        alert(`You can only attach up to ${default_data.default_max_files_attachment} file${default_data.default_max_files_attachment > 1 ? 's' : ''}.`);
        return updatedFiles.slice(0, default_data.default_max_files_attachment);
      }
      return updatedFiles;
    });

    event.target.value = null;
  }

  function handleAudio(blob, chatInput, setChatInput) {
    // Send the Blob to the API
    if (validateFile(blob)) {
      var token = getToken();
      if (token === false) {
        return;
      }

      setIsLoading(true);
      setLoadingText('Please wait, loading...');

      const formData = new FormData();
      formData.append('file', blob, 'audio.mp4'); // Add the Blob to the form data
      formData.append('strategy', 'auto');

      try {
        fetch(default_data.default_chat_service_url_files + '/file', {
          method: 'POST',
          headers: {
            'x-access-tokens': `${token}`,
            'Connection': 'keep-alive' // Add this line
          },
          body: formData,
          timeout: 1200000 // 20 minutes in milliseconds
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('An error occurred while getting data.');
          })
          .then(data => {
            var ret = 'Internal error, please contact customer support with more information about your file'

            if (data['status'] == '200') {
              if (typeof data['ret'] === 'object') {
                if ('text' in data['ret']) {
                  ret = removeMetadata(data['ret'].text);
                }
                else {
                  ret = 'Internal error, please contact customer support with more information about your file [2]'
                }
              }
              else {
                ret = removeMetadata(data['ret'])
              }
            }
            else if (data['response'] === 'No file too large') {
              ret = 'File too large, please contact customer support with more information about your file'
            }
            else if (data['response'] === 'Virus detected in file') {
              ret = 'Virus detected in file, please contact customer support with more information about your file'
            }
            else if (data['response'] === 'File type not allowed') {
              ret = 'File type not allowed, please contact customer support with more information about your file'
            }
            if (chatInput.length > 0) {
              setChatInput(chatInput + '\n' + ret)
            }
            else {
              setChatInput(ret)
            }
            setIsLoading(false);
          })
          .catch(error => {
            setIsLoading(false);
            console.log(error);
          });
      }
      catch (error) {
        setIsLoading(false);
        console.log(error)
      }
    }
  }

  function loadPersonas() {
    var token = getToken()
    if (token === false) {
      logout()
      return;
    }

    fetch(default_data.default_chat_service_url + '/get-personas', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },
      body: JSON.stringify({
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        var res = data.response;
        if (data != null && data.status == '200') {
          res.sort((a, b) => {
            const nameA = a['name'].toUpperCase();
            const nameB = b['name'].toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          setPersonas(res)
        }
        else if (data != null && data.status == '400') {
          if (data.response.indexOf('Token is invalid') > -1) {
            logout()
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function loadDatasets() {
    var token = getToken()
    if (token === false) {
      logout()
      return;
    }

    fetch(default_data.default_user_service_url_no_cac + '/get-datasets-with-permissions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },
      body: JSON.stringify({
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if (data != null && data.status == '200') {
          var res = data.response;

          var names = res.map(item => item.dataset);

          names.sort((a, b) => {
            const nameA = a.toUpperCase();
            const nameB = b.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          setDatasets(names);
          setDatasetPermissions(res);

          var edit_only = res.filter(item => item.permissions === 'edit' || item.permissions === 'owner' || item.permissions === 'admin');
          var edit_only_names = edit_only.map(item => item.dataset);

          setDatasetEditOnly(edit_only_names);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function loadDatasetsWithPromise() {
    return new Promise((resolve, reject) => {
      var token = getToken();
      if (token === false) {
        logout();
        reject('Token is invalid');
        return;
      }

      fetch(default_data.default_user_service_url_no_cac + '/get-datasets-with-permissions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },
        body: JSON.stringify({})
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if (data != null && data.status == '200') {
            var res = data.response;

            var names = res.map(item => item.dataset);

            names.sort((a, b) => {
              const nameA = a.toUpperCase();
              const nameB = b.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setDatasets(names);
            setDatasetPermissions(res);

            var edit_only = res.filter(item => item.permissions === 'edit' || item.permissions === 'owner' || item.permissions === 'admin');
            var edit_only_names = edit_only.map(item => item.dataset);

            setDatasetEditOnly(edit_only_names);
            resolve();
          } else {
            reject('Failed to load datasets');
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }

  function loadSecrets() {
    var token = getToken()
    if (token === false) {
      logout()
      return;
    }

    fetch(default_data.default_chat_service_url + '/get-secrets', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },
      body: JSON.stringify({
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        var res = data.response;
        if (data != null && data.status == '200' && res != null) {
          res.sort((a, b) => {
            const nameA = a.toUpperCase();
            const nameB = b.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          setSecrets(res)
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  async function loadChats() {
    setIsLoading(true);
    setLoadingText('Getting things ready...');

    var chats = await getChats()
    if (chats === null) {
      setCurrentChats([]);
      setChatButton([]);
      setIsLoading(false);
      return;
    }

    for (const element of chats.chats) {
      for (const sub_element of element.content) {
        if (sub_element.message_orig !== undefined && sub_element.message_orig !== null && sub_element.message_orig !== '') {
          var parsed_message = await parseMessage(random_element, unEscapeHTML(sub_element.message_orig));
          sub_element.message = parsed_message['message'];
          sub_element.images = parsed_message['images'];
        }
        var ret_parse_tools = parseToolCalls(sub_element)
        if (ret_parse_tools !== null) {
          sub_element.message = ret_parse_tools['message'];
          sub_element.code = ret_parse_tools['code'];
          sub_element.content = ret_parse_tools['content'];
        }
        if (sub_element.message !== undefined && sub_element.message !== null && sub_element.message.indexOf('<convert_code>') !== -1) {
          sub_element.message = loadPendingCode(sub_element.message);
        }
      }
    }

    setCurrentChats(chats.chats);
    setChatButton(chats.buttons);

    // loop through chats to find a chat that is not code

    var found = false;
    for (const element of chats.chats) {
      if (checkMode(chats.chats, element.id, 'chat')) {
        changeChat(element.id.toString(), chats.chats);
        found = true;
        break;
      }
    }

    if (chats.chats.length === 0 || found === false) {
      newChat()
    }
    setIsLoading(false);
  }

  function voteDown(uuid) {
    var token = getToken()
    if (token === false) {
      return;
    }

    fetch(default_data.default_chat_service_url + '/vote-down', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },
      body: JSON.stringify({
        uuid: uuid
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if (data != null && data.status != 200) {
          console.log(data)
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function getTokenizer(string) {

    setTokensCount(0)
    var token = getToken()
    if (token === false) {
      return;
    }

    if (string == null || string == '') {
      return;
    }

    let embedding_model = 'openai_gpt';
    try {
      fetch(default_data.default_chat_service_url + '/tokenizer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },
        body: JSON.stringify({
          content: string,
          model: embedding_model
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if (data != null && data.status != 200) {
            console.log(data)
          }
          else {
            var cur_tokens = parseInt(data.response);
            setTokensCount(cur_tokens)
          }
        })
        .catch(error => {
        });
    }
    catch {
      setTokensCount(0)
    }
  }

  useEffect(() => {
    if (loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    if (getWithExpiry('loss-pass') === true) {
      window.location = '/update?action=force_password';
      return;
    }

    if (getWithExpiry('currentMode') !== null && getWithExpiry('currentMode') === 'simple') {
      setCurrentMode('simple');
    }

    if (loadUserHistory && !startNewChat) {
      loadChats();               // current behaviour
    } else {
      newChat();                 // blank welcome chat only
    }

    loadPersonas()
    setInterval(loadPersonas, 10 * 60 * 1000);

    loadDatasets()
    loadSecrets()
    var user = getUser()
    if (isBotLoggedIn()) {
      if (getBotSettingItem('force_new_chat') === true) {
        clearChat()
      }
    }

    setPaid(user.paid)
    if (user.stripe_customer_id != null && user.stripe_customer_id != '') {
      sethasStripeID(true)
    }
    else {
      sethasStripeID(false)
    }

    var model_first = userState.defaultModel
    if (model_first === 'auto' && user.paid != true) {
      setCurrentModel(default_data.default_allowed_models[1])
    }
    else {
      setCurrentModel(model_first)
    }

    setUser(user)

    setCUIAuth(false)
    if (user.cac_auth && (user.cac_auth === 'true' || user.cac_auth === true)) {
      setCACAuth(true)
      setCUIAuth(true)
    }
    else {
      setCACAuth(false)
      setCUIAuth(false)
    }

    if (user.is_cui_mfa_authorized && user.is_cui_mfa_authorized === true && user.mfa_auth && (user.mfa_auth === 'true' || user.mfa_auth === true)) {
      setCUIAuth(true)
    }

    setName(getName())
    loadChatLog()
    setCurrentPersona(userState.defaultPersonality)
    // check local storage for chat input
    var chatInput = localStorage.getItem('chatInput');
    if (chatInput !== null) {
      setChatInput(chatInput);
    } else {
      localStorage.setItem('chatInput', 'simple');
    }
  }, [])

  useEffect(() => {
    setCurrentDataset(userState.defaultDatasets)
  }, [userState])

  // clear chats
  function clearChat() {
    setFiles([]);
    setFinalMessages([]);
    setChatMode('chat')
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }], currentChatIndex, false);
  }

  function newChat() {
    var new_index = uuidv4();
    setFiles([]);
    setCurrentChatIndex(new_index)
    changeChat(new_index)
    setChatMode('chat')
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }], new_index, false, true)
  }
  var random_element = document.createElement('div');

  function loadChatLog() {
    if (currentChatsRef.current.length === 0) {
      return setChatLog([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }])
    }
    else {
      const curChat = currentChatsRef.current[0]
      if (curChat != null) {
        setCurrentChatIndex(curChat.id)
        setChatLog(curChat.content)
      }
    }
  }

  function changeChat(chatId, updatedChats = null) {
    setCurrentChatIndex(chatId);

    if (updatedChats === null) {
      updatedChats = currentChatsRef.current;
    }
  }

  function setChatLogAndSave(chatLog, index = currentChatIndex, no_save = false, force_visible = false) {
    index = index.toString();

    updateChatData(chatLog, index);

    // Only update the UI if this chat is currently active.
    updateVisibleChat(chatLog, index, force_visible);

    var newButton = [...chatButtonRef.current];
    const curButton = newButton.find(a => a.key === index);
    if (curButton != null) {
      if (curButton.content.substring(0, 5) === "Chat ") {
        curButton.content = "Chat " + new Date().toLocaleString();
        setChatButton(newButton);
      }
      if (no_save === false && saveUserChat === true) {
        if (!updateChat(index, curButton.content, chatLog)) {
          log.error('updateChat: failed to update chat ' + index)
        }
      }
    }
    else {
      var cur_title = "Chat " + new Date().toLocaleString();
      newButton = [
        { key: index, content: cur_title }, // and one new item at the end        
        ...chatButtonRef.current // that contains all the old items        
      ]
      setChatButton(newButton);
    }
    return chatLog
  }


  function updateChatData(newChatLog, index) {
    index = index.toString();

    var newChat = [...currentChatsRef.current];
    const curChat = newChat.find(a => a.id === index);
    if (curChat != null) {
      curChat.content = newChatLog;
      setCurrentChats(newChat);
    }
    else {
      newChat = [
        { id: index, content: newChatLog }, // and one new item at the end
        ...currentChatsRef.current // that contains all the old items
      ]
      setCurrentChats(newChat);
    }
  }

  function updateVisibleChat(chatLog, index, force_visible) {
    if (force_visible === true || index.toString() === currentChatIndexRef.current.toString()) {
      setChatLog(chatLog);
    }
  }

  function addReferences(index_id, data, max_size = 250, index, chatlog) {

    if (data.references == null || data.references == '') {
      return;
    }

    var references = data.references
    var references_array = []
    var references_descriptions = [] // New array to store descriptions

    // List of delimiters
    var delimiters = [
      ' - Video Description:',
      ' - Summary:',
      ' - Data:',
      ' - Article:',
      ' - Article Description:',
      ' - Content:',
      ' - Sage:'
    ];

    let refArray = references.split("\n");
    refArray.forEach((element) => {
      element = strip(element);
      var index = -1;
      var description = ''; // Variable to store description
      if (element != '') {
        // Iterate over delimiters
        for (let delimiter of delimiters) {
          if (element.indexOf(delimiter) !== -1) {
            index = element.indexOf(delimiter);
            description = element.substring(index + delimiter.length); // Store description
            element = element.substring(0, index);
            break; // Break the loop as soon as a delimiter is found
          }
        }
        if (index === -1) {
          if (element.length > max_size) {
            description = element;
            element = element.substring(0, max_size) + '...';
          }
          else {
            description = ''; // If no delimiter is found, description is empty
          }
        }
        references_array.push(urlify(escapeHTML(element)))
        references_descriptions.push(escapeHTML(description)); // Push description to array        
      }
    });

    var i = 1;
    var res_references = []
    var res_references_descriptions = []
    while (i <= 20) {
      if (data.message.indexOf('[' + i.toString() + ']') !== -1) {
        references_array.forEach((element) => {
          if (element.indexOf('[' + i.toString() + ']') !== -1) {
            res_references.push(element)
            res_references_descriptions.push(references_descriptions[references_array.indexOf(element)])
          }
        });
      }
      i++;
    }
    var found = findChatLogIndexAndUpdate(index_id, { references: res_references, references_descriptions: res_references_descriptions }, false, chatlog);
    if (found === true) {
      setChatLogAndSave(chatlog, index, true)
    }
  }

  function findChatLogIndexAndUpdate(index_id, array_values, append_message = false, chatlog) {
    var found_element = false;
    chatlog.forEach((element) => {
      if (element['id'] == index_id) {
        for (var field in array_values) {
          if (append_message === true && field === 'message') {
            element[field] = element[field].replace(get_loading_message(theme), '');
            element[field] += array_values[field];
          }
          else {
            element[field] = array_values[field];
          }
        }
        found_element = true;
      }
    });
    return found_element;
  }

  function analyzeUrls(index_id, text, index, chatlog) {

    return new Promise(() => {
      var token = getToken()
      if (token === false) {
        return;
      }

      fetch(default_data.default_chat_service_url + '/analyze-all-links', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },
        body: JSON.stringify({
          content: text
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if (data.status == 200) {
            var error_count = data.error_count
            var found = false;
            chatlog.forEach((element) => {
              if (element['id'] == index_id) {
                element['analysis_failed'] = error_count;
                found = true;
              }
            });
            if (found) {
              setChatLogAndSave(chatlog, index, true)
            }
          }
        })
        .catch(error => {
        });
    });
  }

  function detectDatasetCreated(index_id, inputString) {
    // Regular expression to match the pattern
    const regex = /Dataset [a-zA-Z0-9-]+ created!/;

    // Test the input string against the regular expression
    const isMatch = regex.test(inputString);

    if (isMatch) {
      loadDatasets()
    }
  }

  function detectSecretCreated(index_id, inputString) {
    // Regular expression to match the pattern
    const regex = /Secret added successfully!/;

    // Test the input string against the regular expression
    const isMatch = regex.test(inputString);

    if (isMatch) {
      loadSecrets()
    }
  }

  function cleanChatLogFromSecret(index, chatlog) {
    // Regular expression pattern to match "/add-secret SECRET_NAME VALUE"
    const pattern = new RegExp("^/(add-secret|update-secret)\\s([a-zA-Z0-9]+)\\s([\\s\\S]+)$", "i");

    // Loop through each object in the chatLog array
    chatlog.forEach((element) => {
      // Check if 'message' field matches the pattern
      if (pattern.test(element.message)) {
        // Replace the secret value with asterisks
        element.message = element.message.replace(pattern, (match, p1, p2, p3) => `/${p1} ${p2} *****`);
      }

      // Check if 'message_orig' field matches the pattern
      if (element.message_orig && pattern.test(element.message_orig)) {
        // Replace the secret value with asterisks
        element.message_orig = element.message_orig.replace(pattern, (match, p1, p2, p3) => `/${p1} ${p2} *****`);
      }
    });

    setChatLogAndSave(chatlog, index, false)
    scrollToBottomWrapper(index);
    return chatlog; // Return the updated chatLog array
  }

  function detectDatasetDeleted(index_id, inputString) {
    // Regular expression to match the pattern
    const regex = /Dataset [a-zA-Z0-9-]+ deleted!/;

    // Test the input string against the regular expression
    const isMatch = regex.test(inputString);

    if (isMatch) {
      loadDatasets()
    }
  }

  async function getFollowUps(index_id, index, chatlog) {
    try {
      var token = getToken()
      if (token === null) {

        window.location = '/login';
      }

      var output = trimChatHistoryByCount(chatlog, null, 10)

      var model = await proposeModelCount(default_data, getUser, 2000, null, true)

      var error = false;
      const response = await fetch(default_data.default_chat_service_url + '/follow-up-questions', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-tokens': `${token}`
        },
        body: JSON.stringify({
          message: output,
          model: model,
          dataset: getDatasetValues()
        })
      }).catch(err => {
        error = true
        console.log(err);
      });
      if (error === true) {
      }
      else {
        const data = await response.json();
        if (data.status != 200) {
          if (data.response.indexOf('Token is invalid') !== -1) {
            return;
          }
          else {
            console.log(data)
            return;
          }
        }
        else {
          var follows = []
          var message = data.message;
          if (message.indexOf('<li>') !== -1) {
            // Loop through each <li> element and display its value            
            const li_regex = /<li>([\s\S]*?)<\/li>/g;
            const matches = message.match(li_regex);
            matches.forEach(li => {
              follows.push(li.replace('<li>', '').replace('</li>', ''));
            });
          }
          else if (message.indexOf('- ') !== -1) {
            const itemsArray = message.split("- ");
            itemsArray.forEach((element) => {
              element = strip(element);
              if (element != '') {
                follows.push(element)
              }
            });
          }
          else if (message.indexOf('1.') !== -1) {
            const itemsArray = message.split("\n")
            itemsArray.forEach((element) => {
              element = strip(element);
              var numRegEx = /\d+\.\s/
              if (element != '' && numRegEx.test(element)) {
                var index = element.indexOf(' ');
                element = element.substring(index + 1)
                follows.push(element)
              }
            });
          }
          else if (message.indexOf('?') !== -1) {
            let itemsArray = message.split("\n");
            itemsArray.forEach((element) => {
              element = strip(element);
              if (element != '' && element.indexOf('?') !== -1) {
                follows.push(element)
              }
            });
          }

          var should_fail = false;
          follows.forEach((element) => {
            if (element.toLowerCase().indexOf('anything else you would like to know') !== -1) {
              should_fail = true;
            }
            else if (element.toLowerCase().indexOf('can help you with') !== -1) {
              should_fail = true;
            }
            else if (element.toLowerCase().indexOf('can i help you with') !== -1) {
              should_fail = true;
            }
            else if (element.toLowerCase().indexOf('have any other question') !== -1) {
              should_fail = true;
            }
            else if (element.toLowerCase().indexOf('would you like to know') !== -1) {
              should_fail = true;
            }
            else if (element.toLowerCase().indexOf('i apologize') !== -1) {
              should_fail = true;
            }
            else if (element.toLowerCase().indexOf('made a mistake') !== -1) {
              should_fail = true;
            }
          });

          if (should_fail) {
            return;
          }
          var found = false;
          chatlog.forEach((element) => {
            if (element['id'] == index_id) {
              element['follows'] = follows;
              found = true;
            }
          });
          if (found) {
            setChatLogAndSave(chatlog, index, true)
            scrollToBottomWrapper(index);
          }
        }
      }
      cleanChatLogFromSecret(index, chatlog)
    }
    catch (error) {
      console.error(error);
    }
  }


  const handleSelect = (event) => {
    setTemperature(event.target.value);
  };

  const handleModel = (event) => {
    if (typeof event.target.value === 'string') {
      setCurrentModel(event.target.value);
    }
  };

  const handlePersona = (event) => {
    if (Number.isInteger(event)) {
      setCurrentPersona(event);
    }
    else {
      setCurrentPersona(event.target.value);
    }
  };

  const handleDataset = (options) => {
    setCurrentDataset(options);
  };

  function getDatasetValues() {
    var values = current_dataset.map(option => option.value);
    if (values.includes('all')) {
      values = ['all']
    }
    else if (values.includes('none')) {
      values = ['none']
    }
    return values
  }

  const handleLive = (event) => {
    setLive(parseInt(event.target.value));
  };

  function clickHandlerFollowUp(e, setChatInput) {
    var value = e.target.textContent;
    if (value != '') {
      submitPrompt(value, setChatInput)
      e.target.disabled = true;
    }
  }

  function clickHandlerCopy(e) {
    let el = e.target;
    while (el && el !== e.currentTarget && el.tagName !== "BUTTON") {
      el = el.parentNode;
    }
    var uuid = el.getAttribute('tag');
    if (uuid != '' && uuid != null) {
      var found = false;
      var content = '';
      chatLog.forEach((element) => {
        if (element['id'] == uuid) {
          content = unEscapeHTML(element['message_orig'])
          found = true;
        }
      });
      if (found) {
        el.classList.add('clicked');
        setTimeout(() => {
          el.classList.remove('clicked');
        }, 2000);
        navigator.clipboard.writeText(content);
      }
      else {
        console.log('not found')
      }
    }
  }

  function clickHandlerEdit(id, message, setChatInput) {
    if (id != '' && id != null) {
      chatLog.forEach((element, index) => {
        if (element['id'] == id) {
          const truncatedChatLog = chatLog.slice(0, index);
          setChatInput(unEscapeHTML(message))
          setChatLogAndSave(truncatedChatLog, currentChatIndex, false);
          return;
        }
      });
    }
  }

  function clickHandlerDown(id) {
    if (id != '' && id != null) {
      var found = false;
      chatLog.forEach((element) => {
        if (element['id'] == id) {
          found = true;
        }
      });
      if (found) {
        voteDown(id)
      }
      else {
        console.log('not found')
      }
    }
  }

  function clickHandlerDelete(item) {
    if (item != '' && item != null) {
      // if item is string, search by ['id']
      if (typeof item === 'string') {
        // Filter the chatLog array to exclude the item with the specified uuid
        const updatedChatLog = chatLog.filter(element => element['id'] !== item);
        // Update the chatLog and save the updated list
        setChatLogAndSave(updatedChatLog, currentChatIndex, false);
      }
      else {
        const updatedChatLog = chatLog.filter(element => element !== item);
        setChatLogAndSave(updatedChatLog, currentChatIndex, false);
      }
    }
  }

  function getTokenWindow() {
    return getTokenWindowR(currentModel)
  }

  function isCUICapable() {
    return isCUICapableR(currentModel, live)
  }

  async function getAutoName(prompt) {
    const token = getToken();
    const promptTemplate = `Create a concise and meaningful title for this chat based on the message: ${prompt}. If the message contains only numbers, respond with "Numbers Clarification". If the message contains only punctuation, respond with "Symbol Clarification". If the message is a request for code, describe what the code does without specifying the programming language. Provide only the title of the chat and nothing else.`;

    const formData = new FormData();
    formData.append('message', promptTemplate);
    formData.append('model', await proposeModelCount(default_data, getUser, await getTokenizerR(default_data, getToken, promptTemplate), null, true));
    formData.append('dataset', "none");
    formData.append('live', 0);
    formData.append('streaming', false);

    const response = await fetch(default_data.default_chat_service_url + '/query', {
      method: 'POST',
      headers: { 'x-access-tokens': token },
      body: formData,
      timeout: 1200000
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    if (data['status'] === 200) {
      let autoName = data.message;

      // check if autoName is a string
      if (typeof autoName === 'string') {
        // if length is less than 3, return null
        if (autoName.length < 3) {
          return null;
        }

        // if length is greater than 99, truncate text to 99
        return autoName.length > 99 ? autoName.substring(0, 99) : autoName;
      }
    }
    return null;
  }

  async function setChatAutoName(index, chatLogNew) {
    const firstMeMessage = chatLogNew.find(item => item.user === 'me');
    const filterMeMessages = chatLogNew.filter(item => item.user === 'me');
    const meMessageLength = filterMeMessages.length;

    if (userState.autoNameChats && meMessageLength === 1) {
      const autoChatName = await getAutoName(firstMeMessage.message);
      if (autoChatName === null) {
        return;
      }
      var updatedButton = [...chatButtonRef.current];
      const curButton = updatedButton.find(a => a.key === index.toString());
      if (curButton != null) {
        curButton.content = autoChatName
        setChatButton(updatedButton);
      }
      if (saveUserChat === true) {
        updateChat(index, autoChatName, chatLogNew);
      }
    }
  }

  async function handleSubmit(e, chatInput, setChatInput) {
    e.preventDefault();
    submitPrompt(chatInput, setChatInput)
  }

  async function get_model_info(force_mini = false) {
    return await getModelInfoR(default_data, currentModel, tokens_count, files, force_mini, getUser)
  }

  async function handleResponseStream(chatLogNew, response, index) {

    const reader = response.body.getReader();

    const decoder = new TextDecoder('utf-8'); // Create a TextDecoder instance

    let bufferLeft = ''

    while (true) {
      const { value, done } = await reader.read();
      try {
        if (value === undefined) {
          // check if bufferLeft not empty and if starts and ends with {
          if (bufferLeft !== '' && bufferLeft.startsWith('{')) {
            try {
              var http_response = JSON.parse(bufferLeft);
              if (http_response.status !== 200 && http_response.status !== '200') {
                log.error(`/query_stream: Error 601: ${bufferLeft}`);
                setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 601]`, added_obj: null, type_auth: getTypeAuth() }], index, false);
              }
            }
            catch (error) {
              log.error(`/query_stream: ${error.message}`);
              log.error(`/query_stream: ${error.stack}`);
            }
          }
          return;
        }
        if (done) {
          if (bufferLeft !== '') {
            var ret2 = handleData(chatLogNew, bufferLeft, false, index);
            if (ret2 === null) {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 101]`, added_obj: null, type_auth: getTypeAuth() }], index, false);
            }
            bufferLeft = ''
          }
          break;
        }
        var tmp_text = decoder.decode(value); // Decode the Uint8Array into a string

        var cur_items_text = bufferLeft + tmp_text;

        if (cur_items_text.indexOf('@|@sep@|@') !== -1) {
          var cur_items = cur_items_text.split('@|@sep@|@'); // Split the chunk into lines
          for (const cur_item of cur_items) {
            if (cur_item !== '') {
              var err = handleData(chatLogNew, cur_item, false, index);
              if (err === null) {
                bufferLeft += cur_item;
              }
              else {
                bufferLeft = '';
              }
            }
          }
        }
        else {
          bufferLeft = cur_items_text;
        }
      } catch (error) {
        // For other errors, log and potentially update UI
        log.error(`/query_stream: Error 1: ${error.message}`);
        log.error(`/query_stream: Error stack 2: ${error.stack}`);
        throw error; // Rethrow to be handled by caller
      }
    }
  }

    const findAndReplaceDeepAgentTags = (chatlog) => {
    const updatedChatLog = chatlog.map((item) => {
      if (item.user === "gpt" && item.message && item.deep_agent_id) {
        const id = item.deep_agent_id
        if (id) { 
          const found = finalMessages.find((message) => message.id === id.toString());
          if (found) {
            item.message = found.message
          }
        }
      }
      return item;
    });
    return updatedChatLog;
  }

  async function submitPrompt(input_obj, setChatInput) {
    try {
      var index = currentChatIndex;
      var token = getToken()
      if (token === null) {
        logout()
        return;
      }

      var unescaped_input = input_obj;
      var escaped_input = escapeHTML(input_obj)
                  
      if(escaped_input == '') {
        return;
      }

      if(escaped_input.toLowerCase() === '/clear') {
        clearChat()
        setChatInput("");
        return;
      }
      if(escaped_input.toLowerCase() === '/new') {
        newChat()
        setChatInput("");
        return;
      }

      let prevCommandNew = [...prevCommand, unescaped_input]
      setPrevCommand(prevCommandNew);
      setCommandCount(commandCount + 1);

      var index_new_me_message = uuidv4();
      let chatLogNew = [...chatLog, { user: "me", id: index_new_me_message, file: files, message: escaped_input, added_obj: null, type_auth: getTypeAuth(), deep_agent_id: deep_agent_id} ]

      let force_mini = false;
      if(chatMode === 'deep_agent') {
        force_mini = true;
      }
      var model_info = await get_model_info(force_mini)
      var new_model = model_info.model
      var history_count = model_info.history_count

      var output = trimChatHistoryByCount(chatLogNew, files, history_count)

      let chatLogNew2 = [...chatLogNew, { user: "gpt", message: get_loading_message(theme), added_obj: null} ]
      setChatInput("");
      setChatLogAndSave(chatLogNew2, index, true)

      scrollToBottomWrapper(index);      

      var forced_dataset = getDatasetValues()
      if(isBotLoggedIn() && getBotSettingItem('force_datasets') !== null) {
        forced_dataset = getBotSettingItem('force_datasets')        
      }
      var forced_persona = current_persona
      if(isBotLoggedIn() && getBotSettingItem('force_persona') !== null) {
        forced_persona = getBotSettingItem('force_persona')
      }
      var forced_live = live
      if(isBotLoggedIn() && getBotSettingItem('force_live') !== null) {
        forced_live = getBotSettingItem('force_live')
      }
      var forced_temperature = temperature
      if(isBotLoggedIn() && getBotSettingItem('force_temperature') !== null) {
        forced_temperature = getBotSettingItem('force_temperature')
      }

      output = findAndReplaceDeepAgentTags(output)

      const streamResults = async () => {  
        try {
          const formData = new FormData();
          files.forEach((file) => {
            formData.append('file', file);
          });
          formData.append('message', JSON.stringify(output));
          formData.append('model', new_model);
          formData.append('temperature', forced_temperature);
          formData.append('persona', forced_persona);
          formData.append('dataset', forced_dataset);
          formData.append('live', forced_live);
          formData.append('mode', chatMode);
          if(deep_agent_id !== null) {
            formData.append('deep_agent_id', deep_agent_id);
          }
          formData.append('streaming', true);

          const response = await fetch(default_data.default_chat_service_url + '/query', {
            method: 'POST',
            headers: {
              'x-access-tokens': `${token}`
            },
            body: formData,
            timeout: 1200000, // 20 minutes in milliseconds
          });
          
          if (!response.ok) {
            log.error(`/query_stream: Response Status: ${response.status}`);
            log.error(`/query_stream: Response Headers: ${JSON.stringify(response.headers)}`);        
            throw new Error(`HTTP error! status: ${response.status}`);
          }      
          // if file is not null, and file is a jpg or png, do not clear the file
          try {
            if (files.length > 0) {
              const allAllowed = files.every((file) => {
                const name = file.name.toLowerCase();
                return (
                  name.endsWith(".jpg") ||
                  name.endsWith(".jpeg") ||
                  name.endsWith(".png") ||
                  name.endsWith(".csv") ||
                  name.endsWith(".xlsx")
                );
              });
              if (!allAllowed) {
                setFiles([]);
              }
            }
            else {
              setFiles([]);
            }              
          }            
          catch (error) {
          }
          await handleResponseStream(chatLogNew, response, index, deep_agent_id)
        }
        catch (err) {
          if(deep_agent_id === null) {
            if (!err.message) {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 101]`, added_obj: null, type_auth: getTypeAuth() }], index, false);
            } else if (err.message.includes('Failed to fetch') && files.length > 0 && files[0].name !== '') {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: your attached file might be open in another application (e.g., MS Word). Please close the file opened and try again.`, added_obj: null, type_auth: getTypeAuth() }], index, false);
            } else {
              log.error(`/query_stream: Error: ${err.message}`);
              log.error(`/query_stream: Fetch error stack: ${err.stack}`); // Log the error stack trace
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 202]`, added_obj: null, type_auth: getTypeAuth() }], index, false);
            }
          }
        }
      }
  
      streamResults();
    }
    catch (error) {
      log.error(`/submitPrompt: ${error.message}`);
      log.error(`/submitPrompt: ${error.stack}`);
    }
  }

  async function handlePluginClick(plugin_name, plugin_values, prompt, setChatInput = undefined) {
    try {
      var index = currentChatIndex;
      var token = getToken();
      if (token === null) {
        logout()
        return;
      }

      var unescaped_input = prompt;
      prompt = escapeHTML(prompt)

      let prevCommandNew = [...prevCommand, unescaped_input]
      setPrevCommand(prevCommandNew);
      setCommandCount(commandCount + 1);

      var index_new_me_message = uuidv4();
      let chatLogNew = [...chatLog, { user: "me", id: index_new_me_message, file: files, message: prompt, added_obj: null, type_auth: getTypeAuth() }]

      let force_mini = false;

      var model_info = await get_model_info(force_mini)
      var new_model = model_info.model

      let chatLogNew2 = [...chatLogNew, { user: "gpt", message: get_loading_message(theme), added_obj: null }]
      if (setChatInput !== undefined) {
        setChatInput("");
      }
      setChatLogAndSave(chatLogNew2, index, true)

      var error = false;
      scrollToBottomWrapper(index);

      const streamResults = async () => {
        try {
          const formData = new FormData();
          formData.append('plugin_name', plugin_name);

          // look through items in plugin_values and replace undefined values by null
          for (var key in plugin_values) {
            if (plugin_values[key] === undefined) {
              plugin_values[key] = null;
            }
          }
          formData.append('plugin_values', JSON.stringify(plugin_values));
          formData.append('model', new_model);
          formData.append('live', live);

          const response = await fetch(default_data.default_chat_service_url + '/execute-plugin', {
            method: 'POST',
            headers: {
              'x-access-tokens': `${token}`
            },
            body: formData,
            timeout: 1200000 // 20 minutes in milliseconds
          }).catch(err => {
            error = true
            if (!err.message) {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us.`, added_obj: null, type_auth: getTypeAuth() }], index, false);
            } else {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us.`, added_obj: null, type_auth: getTypeAuth() }], index, false);
            }
          });
          if (!error) {
            await handleResponseStream(chatLogNew, response, index)
          }
        }
        catch (error) {
          setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us.`, added_obj: null, type_auth: getTypeAuth() }], index, false);
        }
      }

      streamResults();
    }
    catch (error) {
      log.error(`/handlePluginClick: ${error.message}`);
      log.error(`/handlePluginClick: ${error.stack}`);
    }
  }

    async function handleData(chatLogNew, ret, log_error=false, index, cur_deep_agent_id=null) {
    var data = null;
    try {
      try {
        data = JSON.parse(ret);
      }
      catch(err) {
        if(log_error) {
          log.error(`/handleData: ${ret}`);
          log.error(`/handleData: ${err.message}`);
        }
        return null;
      }
      if(data === null) {
        return null;
      }
      var index_new_message = uuidv4();
      if(data.uuid != null && data.uuid != '') {
        index_new_message = data.uuid;
      }

      if(data.message !== '' && data.message != null) {    
        if(data.type === 'deep_agent_action') {
          const found_deep_agent_obj = findClarifyingQuestionsAction(data);
          if(found_deep_agent_obj !== null) {
            setDeepAgentID(found_deep_agent_obj['deep_agent_id']);
            cur_deep_agent_id = found_deep_agent_obj['deep_agent_id'];
            data.message = found_deep_agent_obj['message'];
          }
        }

        if (Array.isArray(data.message)) {
          data.message = data.message.join('\n');
        }
        data.message = data.message.replace(' Source: ', "\n\nSource: ");
        data.message = data.message.replace(' Sources: ', "\n\nSources: ");
        data.message = data.message.replace(' Reference: ', "\n\nReference: ");
        data.message = data.message.replace(' References: ', "\n\nReferences: ");
        data.message = data.message.replace(' Reference 1: ', "\n\nReference 1: ");
        data.message = data.message.replace('.Reference: ', ".\n\nReference: ");
        data.message = data.message.replace('.References: ', ".\n\nReferences: ");
        data.message = data.message.replace('.Reference 1: ', ".\n\nReference 1: ");
        data.message = data.message.replace('Reference: 1.', "Reference:\n1.");
        data.message = data.message.replace('References: 1.', "References:\n1.");

        data.message_orig = data.message;

        var ret_parse = await parseMessage(random_element, data.message);
        data.message = ret_parse['message'];
        data.images = ret_parse['images'];

        data.added_obj = JSON.stringify(data.added_obj);

        if(data.type === 'yield') {
          data.message += "\n\n" + get_loading_message(theme);
        }

        var chat_log_update_obj = {message: data.message, file: data.file, embedding_down: data.embedding_down, vectors_down: data.vectors_down, added_obj: data.added_obj, analysis_failed: false, type: data.type, images: data.images, deep_agent_id: cur_deep_agent_id}
        if(data.type !== 'yield') {
          chat_log_update_obj['message_orig'] = data.message_orig
        }
        var cur_chat_log = findChatLogIndexAndUpdate(index_new_message, chat_log_update_obj, true, chatLogRef.current)
        var updatedChatLog = []
        if(cur_chat_log === false) {
          updatedChatLog = setChatLogAndSave([...chatLogNew, { id: index_new_message, user: "gpt", message_orig: `${data.message_orig}`, message: `${data.message}`, embedding_down: `${data.embedding_down}`, vectors_down: `${data.vectors_down}`, added_obj: `${data.added_obj}`, analysis_failed: false, references:null, references_descriptions: null, type: data.type, type_auth: getTypeAuth(), images: `${data.images}`, deep_agent_id: cur_deep_agent_id}], index, false)
        }
        else {
          updatedChatLog = setChatLogAndSave(chatLogRef.current, index, false)
        } 
        
        if(data.type !== 'teach' && data.type !== 'yield' && data.type !== 'deep_agent_creation' && data.type !== 'deep_agent_action') {
          if(data.images) {
          }
          else {
            addReferences(index_new_message, data, 250, index, updatedChatLog)
            analyzeUrls(index_new_message, data.message, index, updatedChatLog)
            getFollowUps(index_new_message, index, updatedChatLog)
            if (!disableAutoname) {
              setChatAutoName(index, updatedChatLog)
            }
          }
        }
        else if(data.type === 'teach') {
          detectDatasetCreated(index_new_message, data.message)
          detectDatasetDeleted(index_new_message, data.message)
          detectSecretCreated(index_new_message, data.message)
          cleanChatLogFromSecret(index, updatedChatLog)
          if (!disableAutoname) {
            setChatAutoName(index, updatedChatLog)
          }
        }
        else if(data.type === 'deep_agent_action' && !disableAutoname) {
          setChatAutoName(index, updatedChatLog)
        }
        else if(data.type === 'deep_agent_creation') {
          setChatMode('chat');
          setDeepAgentID(null);
        }
      }
      else {
        setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Sorry, please try a different prompt - No answer.`, added_obj: null, type_auth: getTypeAuth()} ], index, true)
      }        
      scrollToBottomWrapper(index);        
      return true;
    }
    catch (error) {
      log.error(`/handleData: 2: ${error.message}`);
      log.error(`/handleData: 2: ${error.stack}`);
      return null;
    }
  }

  function loadPendingCode(message) {
    var body = null;

    if (message.indexOf('</convert_code>') !== -1) {
      message = message.replace(/<br \/>/g, '\n');

      let parser = new DOMParser();
      const doc = parser.parseFromString(message, 'text/html');

      var codes = doc.getElementsByTagName('convert_code');
      [...codes].forEach((code) => {
        // horizontal scroll if too long
        var code_inner = code.innerHTML;

        random_element.innerHTML = code_inner;
        code_inner = random_element.textContent;
        code_inner = window.hljs.highlightAuto(code_inner).value

        // Create a new 'code' element and copy the contents of 'convert_code' into it
        const newCode = document.createElement('code');
        newCode.innerHTML = code_inner;

        const div = document.createElement('pre');
        div.className = "code_pre"
        const parent = code.parentElement;

        if (parent != null) {
          // Replace the 'convert_code' element with the new 'code' element
          parent.replaceChild(div, code);
          div.appendChild(newCode);
          const copyButton = document.createElement('button');
          copyButton.className = "code_button";
          copyButton.innerText = 'Copy';
          // Append the copy button to the <code> tag
          div.appendChild(copyButton);
        }
        else {
        }
      });
      body = doc.getElementsByTagName('body');
      if (body.length != 0) {
        message = body[0].innerHTML;
      }
      else {
        message = doc.documentElement.innerHTML;
      }
      return message;
    }
  }

  async function handleChartUpdate(chartContent, error) {
    try {
      setIsChartRendering(true)

      const systemPrompt = `
        You are an AI assistant specialized in fixing Mermaid chart syntax errors. Your task is to correct the provided chart code and ensure it adheres to the correct Mermaid syntax. Pay close attention to the following rules and common issues:

        1. Chart Type Declaration:
          - Start with the correct chart type (e.g., 'xychart-beta', 'flowchart', 'sequenceDiagram').
          - Ensure the chart type is supported by Mermaid.

        2. Component Structure:
          - Include all necessary components (title, axes, data series) in the correct order.
          - Each component should be on a separate line.

        3. Syntax Specifics:
          - For xychart-beta:
            - Use 'title' for the chart title.
            - Define x-axis and y-axis correctly.
            - Use '-->' for axis ranges, e.g., 'y-axis "Label" 0 --> 1000'.
            - Properly format data series (bar, line) with square brackets.
          - For other chart types, adhere to their specific syntax requirements.

        4. Data Formatting:
          - Ensure all data points in a series are of the same type (all numbers or all strings).
          - Use commas to separate data points within square brackets.

        5. Bracket Usage:
          - All opening square brackets [ must have a corresponding closing bracket ].
          - Do not leave any unclosed brackets.

        6. General Formatting:
          - Use proper indentation for readability.
          - End the chart with a newline character.
          - Do not include 'END' or any other termination marker.

        7. Error Correction:
          - Address the specific error mentioned in the error message.
          - Check for and correct any typos in keywords or syntax.

        Your task is to fix the chart while maintaining its original intent and data as much as possible. Return ONLY the corrected Mermaid chart code without any additional explanations.

        Chart Content:
        ${chartContent}

        Error Message:
        ${error}

        Please provide the corrected Mermaid chart code:
        `;

      const token = getToken();
      if (!token) {
        logout();
        return;
      }

      const stripMermaidFence = (src = '') =>
        src
          .replace(/^[\s`]*```mermaid[\t ]*\n?/i, '')
          .replace(/\n?[\t ]*```[\s`]*$/i, '')
          .trim();

      const formData = new FormData();
      formData.append('message', systemPrompt);
      formData.append('model', await proposeModelCount(default_data, getUser, await getTokenizerR(default_data, getToken, systemPrompt), null, true));
      formData.append('dataset', "none");
      formData.append('live', 0);
      formData.append('streaming', false);

      const response = await fetch(default_data.default_chat_service_url + '/query', {
        method: 'POST',
        headers: { 'x-access-tokens': token },
        body: formData,
        timeout: 1200000
      });

      if (!response.ok) {
        setIsChartRendering(false)
        throw new Error('Failed to update chart');
      }

      const data = await response.json();

      if (!data || !data.message) {
        throw new Error('Invalid response from server');
      }

      let fixedChartContent = data.message.trim();

      fixedChartContent = fixedChartContent.replace(/\s*END\s*$/, '');

      fixedChartContent = fixedChartContent.split('\n').map(line => {
        if (line.includes('[') && !line.includes(']')) {
          return line + ']';
        }
        return line;
      }).join('\n');

      if (!fixedChartContent.endsWith('\n')) {
        fixedChartContent += '\n';
      }

      try {
        const clean = stripMermaidFence(fixedChartContent);
        await mermaid.parse(clean);
      } catch (parseError) {
        log.error('Mermaid parse error:', parseError, fixedChartContent);
        setIsChartRendering(false)
        return null
      }

      var index_new_gpt_message = uuidv4();

      const newChartMessage = {
        user: "gpt",
        id: index_new_gpt_message,
        message: "I've fixed the chart for you. Here's the corrected version:\n\n```mermaid\n" + fixedChartContent + "\n```",
        added_obj: null,
        type_auth: getTypeAuth()
      };

      const updatedChatLog = [...chatLog, newChartMessage];

      setChatLogAndSave(updatedChatLog, currentChatIndex, false)

      return fixedChartContent;
    } catch (error) {
      log.error("Error in handleChartUpdate:", error)
      setIsChartRendering(false)
      return null;
    } finally {
      setIsChartRendering(false)
    }
  }

  function getTypeAuth() {
    var type = 'non-cac';
    if (CACAuth === true) {
      type = 'cac';
    }
    return type;
  }

  function setChatLogAndSaveWithScroll(obj) {
    obj['type_auth'] = getTypeAuth()
    setChatLogAndSave([...chatLog, obj], currentChatIndex)
    scrollToBottomWrapper()
  }

  function scrollToBottomWrapper(index = currentChatIndex) {
    if (index.toString() === currentChatIndex.toString()) {
      scrollToBottom()
    }
  }

  function buttonClick(e) {    
    var key = e.target.dataset.key;
    if(key === undefined || key === null) {
      return;
    }
    key = key.toString();
    changeChat(key)
    setSideBarOpen(false)
  }

  function changeChat(chatId, updatedChats = null) {
    setCurrentChatIndex(chatId);
    setFinalMessages([]);

    // Default behavior for regular chats
    setChatMode('chat');
    setDeepAgentID(null);
    closeSidebar();

    if (updatedChats === null) {
      updatedChats = currentChatsRef.current;
    }
    
    const curChat = updatedChats.find(a => a.id.toString() === chatId.toString());
    if (curChat != null) {
      setChatLog(curChat.content);    
      if (curChat.content.length > 0) {
        const lastEntry = curChat.content[curChat.content.length - 1];
        if (lastEntry.type === "deep_agent_action" && lastEntry.deep_agent_id !== null) {
          setDeepAgentID(lastEntry.deep_agent_id);
          setChatMode('deep_agent');
        }
      }
    }
  }

  function deleteClick(key) {
    key = key.toString();

    var count = currentChatsRef.current.length;

    var newChats = currentChatsRef.current.filter(a => a.id !== key)
    setCurrentChats(
      newChats
    );

    var newChatButton = chatButtonRef.current.filter(a => a.key !== key)
    setChatButton(
      newChatButton
    );

    if(count === 1 || count === 0) {
       //newChat()
    }
    else {
      const curChat = currentChatsRef.current.find(a => a.id !== key.toString());
      if(curChat != null) {
        changeChat(curChat.id.toString())
      }
    }

    if(!deleteChat(key)) {
      log.error('deleteChat: failed to delete chat ' + key)
    }
  }

  const loading_styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.9)', // Adjust the opacity as needed
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Adjust the z-index as needed to ensure it appears above other elements
    },
    loadingText: {
      color: '#fff',
      fontSize: '24px',
    },
  };

  const copyChatToClipboard = (chatKey) => {
    const selectedChat = currentChatsRef.current.find(chat => chat.id === chatKey)
    const messages = selectedChat.content.map(message => {
      var cur_message = message.message
      if (message.message_orig !== undefined && message.message_orig !== null && message.message_orig !== '') {
        cur_message = message.message_orig;
      }

      return `${message.user === 'gpt' ? 'Ask Sage' : 'Me'}: ${unEscapeHTML(cur_message)}\n\n`
    })
    const chatText = messages.join('')
    navigator.clipboard.writeText(chatText)
  }

  function isDescendantType(parentType, child) {
    if (child.tagName.toLowerCase() === parentType.toLowerCase()) {
      return child;
    }
    let node = child.parentNode;
    while (node !== null) {
      if (node.tagName.toLowerCase() === parentType.toLowerCase()) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  Modal.setAppElement('#root');

    const chatContainsDeepAgent = (chatId) => {
    const chat = currentChatsRef.current.find(chat => chat.id === chatId);
    if (chat) {
      const regex = /<deep-agent id="\d+" \/>/;
      const hasDeepAgent = chat.content.some(message => message.type === 'deep_agent_creation' || message.type === 'deep_agent_action');
      if (hasDeepAgent) {
        return true;
      }
      
      return chat.content.some(message => regex.test(message.message));
    }
    return false;
  }

  if (!isLoaded) return null;

  return (
    <GoogleOAuthProvider default_data={default_data} clientId={clientId}>
      <Box
        sx={{
          width: '100%',
          backgroundColor: theme.palette.appBackground,
          height: '100%',
        }}
      >
        {isMobile && !disableMobileHeader && (
          <Stack direction={'row'} justifyContent={disableSidebar ? 'center' : 'space-between'}>
            {!disableSidebar && (
            <IconButton onClick={()=>{setSideBarOpen(true)}} >
              <FiMenu size={24} />
            </IconButton>
            )}
            <div>
              <a href="/dashboard"><img src="logo-menu.png" alt="Ask Sage"/></a>
            </div>
            {!disableSidebar && <Box width={50}></Box>}
          </Stack>
        )}
          <div style={{ width:`100%`, display: 'flex', height: '100%' }} className={` ${((paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')) ? 'longer' : ''} ${isBotLoggedIn() ? 'bot' : ''}`}>
            <EditChat
              inputEditRef={inputEditRef}
              newEditName={newEditName}
              setNewEditName={setNewEditName}
              modalIsEditOpen={modalIsEditOpen}
              closeEditModal={closeEditModal}
              handleEditSubmit={handleEditSubmit}
            />
            <ShareChat
              open={modalIsShareOpen}
              onClose={closeShareModal}
              isShareButtonDisabled={isShareButtonDisabled}
              inputShareRef={inputShareRef}
              successMessage={successShareMessage}
              errorMessage={errorShareMessage}
              chatName={currentShareName}
              setNewShareEmail={setNewShareEmail}
              handleSubmit={handleShareSubmit}
              newShareEmail={newShareEmail}
              currentShareKey={currentShareKey}
            />
            <PersonaList personas={personas} loadPersonas={loadPersonas} setTriggerPersonaList={setTriggerPersonaList} triggerPersonaList={triggerPersonaList} handlePersonaClick={handlePersona} default_data={default_data} getToken={getToken} getUser={getUser} />
            {
              isBotLoggedIn() && getBotSettingItem('hide_chat_history') === true || disableSidebar ?
              ''
              :
              <SideMenu
                default_data={default_data}
                mode={'chat'}
                currentChats={currentChats}
                chatButton={chatButton}
                buttonClick={buttonClick}
                newChat={newChat}
                currentChatIndex={currentChatIndex}
                deleteClick={deleteClick}
                editClick={editClick}
                shareClick={shareClick}
                clearChat={clearChat}
                setSideBarOpen={setSideBarOpen}
                sideBarOpen={sideBarOpen}
                copyChatToClipboard={copyChatToClipboard}
                hideSideBar={hideSideBar}
                setHideSideBar={setHideSideBar}
                chatContainsDeepAgent={chatContainsDeepAgent}
                getBotSettingItem={getBotSettingItem}
                getUser={getUser}
                getWithExpiry={getWithExpiry}
                isBotLoggedIn={isBotLoggedIn}
                setWithExpiry={setWithExpiry}
                getToken={getToken}
                Navbar={Navbar}
              />
            }
            <ChatBox
              currentMode={currentMode}
              currentModel={currentModel}
              chatLog={chatLog}
              cur_user={cur_user}
              handleSelect={handleSelect}
              handleModel={handleModel}
              showSimpleIngest={showSimpleIngest}
              showPersonaList={showPersonaList}
              showCopyData={showCopyData}
              showAddDataset={showAddDataset}
              handleLive={handleLive}
              live={live}
              chatMode={chatMode}
              handleChatMode={handleChatMode}
              paid={paid}
              files={files}
              setFiles={setFiles}
              personas={personas}
              current_persona={current_persona}
              handlePersona={handlePersona}
              datasets={datasets}
              datasetPermissions={datasetPermissions}
              current_dataset={current_dataset}
              handleDataset={handleDataset}
              temperature={temperature}
              clickHandlerFollowUp={clickHandlerFollowUp}
              clickHandlerCopy={clickHandlerCopy}
              clickHandlerDelete={clickHandlerDelete}
              clickHandlerDown={clickHandlerDown}
              clickHandlerEdit={clickHandlerEdit}
              handleAudio={handleAudio}
              tokens_count={tokens_count}
              getTokenWindow={getTokenWindow}
              isCUICapable={isCUICapable}
              handleFileChange={handleFileChange}
              handleSubmit={handleSubmit}
              getTokenizer={getTokenizer}
              prevCommand={prevCommand}
              secrets={secrets}
              setChatLogAndSaveWithScroll={setChatLogAndSaveWithScroll}
              setCurrentPersona={setCurrentPersona}
              handlePluginClick={handlePluginClick}
              chatInput={chatInput}
              setChatInputMode={setChatInput}
              maxFiles={default_data.default_max_files_attachment}
              handleChartUpdate={handleChartUpdate}
              isChartRendering={isChartRendering}
              addOrUpdatFinalMessage={addOrUpdatFinalMessage}
              default_data={default_data}
              isBotLoggedIn={isBotLoggedIn}
              getBotSettingItem={getBotSettingItem}
              getUser={getUser}
              getToken={getToken}
              userState={userState}
              deepAgentSidebarRef={deepAgentSidebarRef}
              isDeepAgentDrawerOpen={isDeepAgentDrawerOpen}
              widthStandard={widthStandard}
              widthOffset={widthOffset}
              hideSidebar={hideSideBar}
              disableSidebar={disableSidebar}
              disableDeepAgent={disableDeepAgent}
              hidePluginSelect={hidePluginSelect}
              hidePromptSelect={hidePromptSelect}
            />
            {!disableDeepAgent && 
              <DeepAgentSidebar ref={deepAgentSidebarRef} onOpenChange={handleSidebarOpenChange} />
            }
          </div>
        <FilePopup paid={paid} showAddDataset={showAddDataset} datasets={datasets} datasetPermissions={datasetPermissions} setTriggerFilePopup={setTriggerFilePopup} triggerFilePopup={triggerFilePopup} default_data={default_data} getToken={getToken} loadGoogleClientId={loadGoogleClientId} />
        {triggerFilesPopup && (
          <FileManagementDialog
            datasetNames={datasetEditOnly}
            datasetPermissions={datasetPermissions}
            loadDatasets={loadDatasetsWithPromise}
            setTriggerFilesPopup={setTriggerFilesPopup}
            triggerFilesPopup={triggerFilesPopup}
            triggerIngestPopup={showSimpleIngest}
            ingestPopup={triggerFilePopup}
            default_data={default_data}
            getToken={getToken}
            getUser={getUser}
          />
        )}
        <AddDatasetPopup loadDatasets={loadDatasets} setTriggerDatasetPopup={setTriggerDatasetPopup} triggerDatasetPopup={triggerDatasetPopup} default_data={default_data} getToken={getToken} />
        {/* Loading overlay */}
        {isLoading && (
          <div style={loading_styles.overlay}>
            <span style={loading_styles.loadingText}>{loadingText}</span>
          </div>
        )}
      </Box>
    </GoogleOAuthProvider>
  );
}

export default CoreChat;
